<template>
    <Form :rules="innerRules" :model="info" ref="rentMode">
        <div v-if="finalViewonly" style="padding-left: 7px">
            {{ dict.depositPayMethod.val(info.depositPayMethod) }} 付
            {{ dict.rentPayMethod.val(info.rentPayMethod) }}
        </div>
        <div class="flex" v-else>
            <span v-show="isTranslation">押金平移</span>
            <FormItem
                v-show="!isTranslation"
                class="rent-field flex-item grow"
                prop="depositPayMethod"
            >
                <Select
                    v-model="info.depositPayMethod"
                    transfer
                    :disabled="depositPayMethodDisable"
                >
                    <Option
                        v-for="(item, index) in depositPayMethodList"
                        :value="item.id"
                        :key="index"
                        >{{ item.text }}</Option
                    >
                </Select>
            </FormItem>
            <span style="margin: 0 10px">付</span>
            <FormItem class="rent-field flex-item grow" prop="rentPayMethod">
                <Select
                    v-model="info.rentPayMethod"
                    transfer
                    :disabled="rentPayMethodDisable"
                >
                    <Option
                        v-for="(item, index) in rentPayMethodList"
                        :value="item.id"
                        :key="index"
                        >{{ item.text }}</Option
                    >
                </Select>
            </FormItem>
        </div>
    </Form>
</template>
<script>
import { Field } from 'ivux'

// 交租方式
export default {
    name: 'RentMode',

    mixins: [Field],

    props: {
        // 交租方式(押金)
        depositPayMethod: {
            type: [Number, String],
            default: '',
        },
        // 交租方式(租金)
        rentPayMethod: {
            type: [Number, String],
            default: '',
        },
        // 押金方式禁用
        depositPayMethodDisable: {
            type: Boolean,
            default: false,
        },
        // 租金方式禁用
        rentPayMethodDisable: {
            type: Boolean,
            default: false,
        },
        // 是否押金平移
        isTranslation: {
            type: Boolean,
            default: false,
        },
        // 是否需要校验
        isVerify: {
            type: Boolean,
            default: false,
        },
        // 默认透明传输
        populateType: {
            type: String,
            default: 'through',
        },
    },

    data() {
        return {
            info: {
                depositPayMethod: this.depositPayMethod,
                rentPayMethod: this.rentPayMethod,
            },
            dict: {
                depositPayMethod: this.$dict.NULL,
                rentPayMethod: this.$dict.NULL,
            },
        }
    },

    watch: {
        depositPayMethod(val) {
            this.info.depositPayMethod = val
        },
        rentPayMethod(val) {
            this.info.rentPayMethod = val
        },
        info: {
            handler(val) {
                this.$emit('on-change', val)
            },
            deep: true,
        },
    },

    computed: {
        depositPayMethodList() {
            return this.dict.depositPayMethod.toList()
        },
        rentPayMethodList() {
            return this.dict.rentPayMethod.toList()
        },
        innerRules() {
            return this.isVerify
                ? {
                      depositPayMethod: [
                          { required: true, message: '押金方式必填' },
                      ],
                      rentPayMethod: [
                          { required: true, message: '交租方式必填' },
                      ],
                  }
                : {}
        },
    },

    created() {
        this.$dict
            .get(['deposit_pay_method', 'rent_pay_method'])
            .then((dictGroup) => Object.assign(this.dict, dictGroup))
    },
    mounted() {
        // console.log(this.$refs.rentMode);
    },

    methods: {},
}
</script>
<style lang="less" scoped>
.rent {
    &-field {
        flex-basis: 20px;
    }
}
</style>
